export default "__VITE_ASSET__C2QLvU4f__"